module.exports = __webpack_public_path__ + "src/app/_content/imgs/bmw/discover/myBMW.jpg?2023f0d85ac23e099c85f118a145a517";